import { t } from '../ui/lang';
/**
 * Setup tab of a Mercado API farm: how to get a Mercado Pago production Access Token and
 * the account's CVU — the pair every device of this farm is created from. Nothing is
 * installed: the mercado-runner on the panel host does the polling.
 */
/** Steps 1–5 (token + CVU) are also shown inside the add-account modal; 6–7 are farm-page steps. */
export function mercadoStepsHtml(steps) {
    return steps
        .map((n) => `<li class="modal__text" style="margin-top:8px">${t(`farms.mercado_step${n}`)}</li>`)
        .join('');
}
export function renderMercadoSetupBody(panel) {
    const steps = mercadoStepsHtml([1, 2, 3, 4, 5, 6, 7]);
    panel.innerHTML = `
        <div class="settings-section">
            <h3 class="settings-section__title">${t('farms.mercado_setup_title')}</h3>
            <p class="settings-hint">${t('farms.mercado_setup_hint')}</p>
            <ol style="padding-left:20px;margin:8px 0 0">${steps}</ol>
        </div>
        <div class="settings-section">
            <h3 class="settings-section__title">${t('farms.mercado_setup_farm_title')}</h3>
            <p class="settings-hint">${t('farms.mercado_setup_farm_hint')}</p>
        </div>
    `;
}
